// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","header":"Footer_header__dnSM4","handles":"Footer_handles__RxO7r"};